interface IDefaultValues {
  [key: string]: any
}

export default function getDefaultValues(
  settings: IApplicationSettingKeyed[],
  userAppValues: IDefaultValues | null,
  permissions: IPermissionKeyed[],
  noNullValues = false
): IDefaultValues | undefined {
  const settingsValues = settings
    .map(setting => {
      if(setting.type === 'number') {
        return { [setting.key]: (setting.default || setting.default === 0) ? Number(setting.default) : null }
      }
      return ({ [setting.key]: setting.default })
    })
    .reduce((obj, item) => {
      const [key, value] = Object.entries(item)[0] as unknown as string
      if((userAppValues && userAppValues[key]) || value !== undefined) {
        obj[key] = (userAppValues && userAppValues[key] !== undefined) ? userAppValues[key] as string : value
      }
      if(noNullValues && obj[key] === null) {
        delete obj[key]
      }
      return obj
    }, {})

  const permissionsValues: IPermissionValues = permissions
    .reduce((obj, item) => {
      const { key, value } = item
      obj[key] = value
      return obj
    }, {} as IPermissionValues)

  return {
    ...settingsValues,
    ...permissionsValues,
  }
}
